import React from 'react'
//import GlobalStyles from '../styles/GlobalStyle'
//import Typography from '../styles/Typography'
import { motion, AnimatePresence } from 'framer-motion'
 

const duration = 0.3;

const variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: {
      duration: duration,
      delay: duration,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0 },
  },
};


export default function Pagetransition({ children, location }) {

  return (
        <>
        <AnimatePresence>
        <motion.main 
          className="main mt-20_ pb-10 pb-md-20"
          key={location.pathname}
          variants={variants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          {children}
        </motion.main>
      </AnimatePresence>
    </>
  )
}